import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'
// controllers
import HeaderController from './controllers/HeaderController'
import AmznController from './controllers/AmznController'
import RepositoryController from './controllers/RepositoryController'
import ContextController from './controllers/ContextController'
import DblimgController from './controllers/amznobj/DblimgController'
import SpecialController from './controllers/amznobj/SpecialController'
// views
import AmznWebflowView from './views/AmznWebflowView'
import RepoView from './views/RepoView'
import WorkcardView from './views/WorkcardView'
import { checkAmznModals, hideAllModals } from './amzn/modals'
import { closeImgFull } from './amzn/imgfull'


const routes = {
  'header': {
    controller: HeaderController
  },
  'item_full': {
    controller: AmznController,
    view: AmznWebflowView
  },
  'repo_full': {
    controller: RepositoryController,
    view: RepoView
  },
  'workcard_full': {
    controller: AmznController,
    view: WorkcardView
  },
  'context': {
    controller: ContextController,
    view: AmznWebflowView
  },
  // amzobj
  'dblimg_main': {
    controller: DblimgController
  },
  'special': {
    controller: SpecialController
  },
}


const aswapProps = {
  animationTimeHide: 1000,
  animationTimeShow: 800,
  preloadOnHover: false, // dont use preload (WorkerProcess)!
  cacheOn: false, // dont use cahce (WorkerProcess)!
  refreshOnSameUrl: false,
  routes,
  trace,
}
const aswapEvents = {
  onViewSwapComplete: () => {
    checkAmznModals()
  },
  onViewHide: () => {
    // close menu
    document.documentElement.classList.remove('hamburger-menu-open')
    // hidemodals
    hideAllModals()
    // close amzn img full
    closeImgFull()
  }
}



export const initASwap = () => {
  RytmWebflow.aswap.init(aswapProps, aswapEvents)
}